import { toPlainTextSync } from '@wix/ricos';
export const getRichContentText = (contentState, delimiter = '') => {
    return toPlainTextSync(contentState, {
        urlShortener: () => '',
        getVideoUrl: () => '',
        getAudioUrl: () => '',
        getVideoEmbeddedUrl: () => '',
        getGifUrl: () => '',
        addLinksToText: false,
        delimiter,
    });
};
//# sourceMappingURL=get-rich-content-text.js.map